import { AdminClient } from './AdminClient';

export default AdminClient;